/**
 * UTC 날짜 문자열을 로컬 시간대로 변환합니다.
 * @param {string} utcDateStr - UTC 날짜 문자열 (ISO 형식)
 * @returns {Date} 로컬 시간대로 변환된 Date 객체
 */
export const convertUTCtoLocal = (utcDateStr) => {
  const date = new Date(utcDateStr);
  return date;
};

/**
 * 날짜를 "1st", "2nd", "3rd", "4th" 등의 서수형으로 변환합니다.
 * @param {number} day - 날짜 (1-31)
 * @returns {string} 서수형으로 변환된 날짜 문자열
 */
export const getDayWithSuffix = (day) => {
  if (day >= 11 && day <= 13) {
    return `${day}th`;
  }
  
  switch (day % 10) {
    case 1: return `${day}st`;
    case 2: return `${day}nd`;
    case 3: return `${day}rd`;
    default: return `${day}th`;
  }
};

/**
 * 날짜를 "1st January", "2nd July" 등의 영문 형식으로 변환합니다.
 * @param {Date} date - 변환할 Date 객체
 * @returns {string} 영문 형식의 날짜 문자열
 */
export const formatDateToEnglish = (date) => {
  const day = date.getDate();
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const month = monthNames[date.getMonth()];
  
  return `${month} ${getDayWithSuffix(day)}`;
};

/**
 * UTC 날짜 문자열을 "2nd July" 형식으로 변환합니다.
 * @param {string} utcDateStr - UTC 날짜 문자열 (ISO 형식)
 * @returns {string} "2nd July" 형식의 날짜 문자열
 */
export const formatUTCtoEnglishDate = (utcDateStr) => {
  const localDate = convertUTCtoLocal(utcDateStr);
  return formatDateToEnglish(localDate);
}; 